import { useQuery } from '@tanstack/react-query';
import Client from './client';
import type { UseQueryOptions } from '@tanstack/react-query';

export const useParkingRecordBills = (
  {
    parkinglotId,
    plateNumber,
    vehicleType,
  }: {
    parkinglotId: string;
    plateNumber: string;
    vehicleType: string;
  },
  options: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof Client.fetchParkingRecordBills>>>,
    'queryFn' | 'queryKey'
  > = {},
) => {
  const {
    data,
    refetch: refetchParkingRecordBills,
    status: getParkingRecordBillsStatus,
    error: getParkingRecordBillsError,
    isLoading,
  } = useQuery({
    queryKey: ['parking_record_bills', parkinglotId, plateNumber, vehicleType],
    queryFn: () =>
      Client.fetchParkingRecordBills({
        parkinglotId,
        plateNumberFuzzy: plateNumber,
        vehicleType,
      }),
    enabled: false,
    refetchInterval: false,
    ...options,
  });

  const parkingRecordBills = data?.data?.data ?? [];

  return {
    refetchParkingRecordBills,
    parkingRecordBills,
    getParkingRecordBillsStatus,
    getParkingRecordBillsError,
    isGetParkingRecordBillsLoading: isLoading,
  };
};
